import { FC } from "react"
import classNames from "classnames"
import { Icon, IconColor } from "@/components/shared/Icon"

type VitalItemProps = {
   inmateMoving?: boolean
   value: number | null
   title: string
   subTitle?: string
   vitalStable?: boolean
   totalCount?: number | null
}

const VitalItem: FC<VitalItemProps> = ({
   inmateMoving = false,
   value,
   title,
   subTitle,
   vitalStable = true,
   totalCount,
}) => {
   return (
      <span
         className={classNames("vital-summary-card__vital-item", {
            "vital-summary-card__vital-item--unstable": !vitalStable,
         })}
      >
         <span className="vital-summary-card__vital-item-row">
            <span className="vital-summary-card__vital-value">
               {inmateMoving ? (
                  <Icon
                     name="movement"
                     size="36"
                     color={IconColor.HONOLULU_BLUE}
                  />
               ) : vitalStable ? (
                  value || "-"
               ) : (
                  "-"
               )}
            </span>
            <span className="vital-summary-card__vital-info">
               <span className="vital-summary-card__vital-info-title">
                  {title}
               </span>
               <span className="vital-summary-card__vital-info-subtitle">
                  {inmateMoving ? "Inmate moving" : subTitle || ""}
               </span>
            </span>
         </span>
         {totalCount != null && (
            <span className="vital-summary-card__vital-total-count">
               Total Count: {totalCount}
            </span>
         )}
      </span>
   )
}

export default VitalItem
